export const getUserDeaprtment = (departments, userId) =>
	departments?.find(
		(d) => d.users?.includes(userId) || d.head_of_department === userId,
	);
